import { parseUtmParamsFromCookies, setFormValueForUtmParam } from 'core-events';
import Script from 'next/script';
import React, { ReactElement } from 'react';
import cookie from 'react-cookies';

import '../layouts/hubspot.css';

// types/hubspot.d.ts
declare global {
    interface Window {
        hbspt?: HubSpotForms;
    }
}

interface HubSpotForms {
    forms: {
        create: (options: HubSpotFormOptions) => HubSpotForm;
    };
}

interface HubSpotFormOptions {
    portalId: string;
    formId: string;
    region?: string;
    target?: string;
    cssClass?: string;
    css?: string;
    submitButtonClass?: string;
    errorClass?: string;
    errorMessageClass?: string;
    submitText?: string;
    redirectUrl?: string;
    inlineMessage?: string;
    locale?: string;
    translations?: Record<string, unknown>;
    formInstanceId?: string;
    pageId?: string;
    contentType?: string;
    formsBaseUrl?: string;
    onBeforeFormInit?: (ctx: unknown) => void;
    onFormReady?: ($form: HTMLFormElement, ctx: unknown) => void;
    onFormSubmit?: ($form: HTMLFormElement) => void;
    onFormSubmitted?: (response: HubSpotFormSubmittedResponse) => void;
    onFormFailedValidation?: ($form: HTMLFormElement) => void;
}

interface HubSpotForm {
    onReady?: (callback: () => void) => void;
}

interface HubSpotFormSubmittedResponse {
    redirectUrl?: string;
    inlineMessage?: string;
    submissionValues?: Record<string, unknown>;
}

interface Props {
    formId: string;
    loadingID?: string;
}

/**
 * This component also exists in shared-components. The two should be kept in sync
 * until shared-components goes away.
 */
//TODO update this with some of the npm package conventions from Hubspot-react
const HubspotForm = ({ formId, loadingID = 'hubspot-form' }: Props): ReactElement => {
    const sanitizedUtmValues = parseUtmParamsFromCookies(cookie.loadAll());
    return (
        <div>
            <Script
                src="https://js.hsforms.net/forms/v2.js"
                onLoad={() => {
                    window?.hbspt?.forms.create({
                        portalId: '885790',
                        formId,
                        target: '#' + loadingID,
                        css: '',
                        cssClass: 'hubspot-class',
                        onFormReady: function (form) {
                            Object.entries(sanitizedUtmValues).forEach(([key, value]) => {
                                setFormValueForUtmParam(form, key, value);
                            });
                        },
                    });
                }}
                onReady={() => {
                    const visitorIdInput: HTMLInputElement | null = document.querySelector(
                        `#hsForm_${formId} input[name="vid"]`,
                    );
                    if (visitorIdInput) {
                        const visitorIdCookie = cookie.load('VID') as string;
                        visitorIdInput.value = visitorIdCookie || '';
                    }
                }}
            />
            <div className="-mt-32 pt-32" id={`${loadingID}`}></div>
        </div>
    );
};

export default HubspotForm;
